import React, { Component } from 'react';
import { BarChart, Bar, CartesianGrid, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Card, Row, Col,Button } from 'reactstrap';
import { getFilterType } from './util';
import { CREDIT_LIMIT_UTILISATION, CREDIT_LIMIT_UTILISATION_DESCRIPTION } from '../constants';



class CreditLimitUtilizationChart extends Component {

    state = {
        barChartProperties: { with_me_color: '', with_cug_member: '', cug_group_color: '' },
        selectedfilter: "Overall", filteredData : []
    }

    componentDidMount() {
        if (this.props.chartData) {
            this.setState({ chartData: this.props.chartData })
        } else {
        }
    }

    componentDidUpdate(prevProps){
        if(prevProps.chartData !== this.props.chartData){
            this.filterData();
        }
    }

    handleTypeFilter = (e) => {
        if (this.state.selectedfilter !== e.target.value) {
            this.setState({ selectedfilter: e.target.value },()=>{
                this.filterData();
            })
        }
        e.preventDefault();
    }

  
    filterData = () => {
        let type = getFilterType(this.state.selectedfilter);
        let filteredData = this.props.chartData.filter(objdata => objdata.type == type);
        this.setState({ filteredData: filteredData })
    }

    render() {
        return (
            <Card body className='mt-3' >
                <div>
                    <h3 className='text-center'>
                        {CREDIT_LIMIT_UTILISATION}
                    </h3>
                    {
                        this.props.typeFilters 
                        && this.props.typeFilters.length > 0 
                        && <select className='position-absolute chart-filter-dropdown' name="typefilter" onChange={(e) => this.handleTypeFilter(e)} value={this.state.selectedfilter}>
                            {this.props.typeFilters.map(optionValue => (<option value={optionValue} key={Math.random()} >{optionValue}</option>))}
                        </select>
                    }
                </div>
                <ResponsiveContainer width='100%' height={300}>
                    <BarChart data={this.state.filteredData}
                        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}  >
                        <CartesianGrid strokeDasharray="3 3" />
                        <YAxis/>
                        <XAxis dataKey="month" />
                        <Tooltip />
                        <Legend style={{ marginTop: `5px !important` }} />
                        <Bar dataKey="me" fill="#5b9bd5" name= {`${this.props.counterpartyName} (With Me)`} />
                        <Bar dataKey="cug" fill="#ed7d31" name={`${this.props.counterpartyName} (With Other CUG Members)`} />
                    </BarChart>
                </ResponsiveContainer>
          
                <details>
                    <summary>
                        <i>Know more...</i>
                    </summary>
                    <p dangerouslySetInnerHTML={{ __html: CREDIT_LIMIT_UTILISATION_DESCRIPTION }}></p>
                </details>
            </Card>
        );
    }
}

export default CreditLimitUtilizationChart;